import React, { useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import "./accounting-form.css";
import { Field, FieldArray, Form, Formik } from "formik";
import FormLoader from "../../../shared-components/FormLoader/FormLoader";
import LoaderButton from "../../../shared-components/button/loader-button";
import { observer } from "mobx-react";
import { useStore } from "../../../contexts/store-provider";
import FormikFormCheckBox from "../../../shared-components/FormikFormHandlers/FormikFormCheckBox";
import { calculateSummary, formatNumberWithCommas, integerRegex } from "../../../constants/constants";
import { accountingValidationSchema } from "../../../shared-components/FormikFormHandlers/FormikValidationSchema";
import {
  IAddSaleItemVM,
  IDiscountType,
  IPaymentSMRVM,
  ISaleRecordList,
  ISaleRecordPaymentInvoiceDetails,
  IStoreSeletedPaymentList,
} from "../../../models/response/ISMRResponse";
import toast from "react-hot-toast";
import { formatMessage } from "../../../translations/format-message";
import { IConsumptionTaxState } from "../../../models/state/IMasterSettingsState";
import { toHalfWidth } from "../../../helpers/validate-helper";
import SMROldNewEnum from "../../../constants/enums/smr-old-new-enum";
import { getBusinessTypeIdFromLocalStorage } from "../../../helpers/localstorage-helper";
import Nodata from "../../../shared-components/no-data-svg/no-data-svg";
import { IOption } from "../../../models/ICommon";
import FormikFormInputRegexCheckFormattedNumber from "../../../shared-components/FormikFormHandlers/FormikFormInputRegexCheckFormattedNumber";

interface IProps {
  saleItems: IAddSaleItemVM[];
  consumptionTax: IConsumptionTaxState;
  overAllDiscountDetails: IDiscountType;
  getAllStaffOptions: IOption[];
  saleRecordItem: ISaleRecordList;
  isDataChanged: boolean;
  smrId: number;
  saleRecordId: number;
  storeId: number;
  customerId: number;
  isAddAccounting: boolean;
  formValues: any;
  allSalesRecord: any;
  modalClosed: () => void;
  isDisabled?: boolean;
}
const Accounting = (props: IProps) => {
  const {
    saleItems, 
    consumptionTax, 
    overAllDiscountDetails, 
    getAllStaffOptions, 
    saleRecordItem, 
    isDataChanged,
    saleRecordId,
    storeId,
    customerId,
    isAddAccounting,
    modalClosed,
    smrId,
    formValues,
    isDisabled,
    allSalesRecord
  } = props;

  // const [invoiceDetails, setInvoiceDetails] = useState<ISaleRecordPaymentInvoiceDetails>({
  //   Subtotal:0,
  //   NominationFee:0,
  //   TaxTotal:0,
  //   OverAllDiscount:0,
  //   TaxBreakdown:{},
  //   ConsumptionTax:0,
  //   TotalAmount:0,
  // })

  const [taxDetail, setTaxDetail] = useState<number>(0); 

  useEffect(() => {
      const result = calculateSummary(saleRecordItem, saleItems, getAllStaffOptions, consumptionTax, overAllDiscountDetails, isDataChanged, saleRecordItem.NominationFee);
      //setInvoiceDetails(result);
      setTaxDetail(result?.TaxTotal + result?.ConsumptionTax)
    }, [saleItems, overAllDiscountDetails]);
    
  const { masterManagementStore, smrStore, customerManagementStore } =
    useStore();
  const {
    GetStorePaymentByStoreId,
    storeSeletedPaymentModesForSMR,
    getByIdPaymentInStoreState,
    GetSMRPaymentDetailsBySaleRecordId,
    paymentDetailBySaleRecordIdState,
  } = masterManagementStore;
  const {
    UpdatePaymentDetailsBySaleRecordIdService,
    addUpdatePaymentDetailsBySaleRecordIdState,
    AddPaymentDetailsBySaleRecordIdService,
  } = smrStore;
  const { customerDetail } = customerManagementStore;
  const [err, setErr] = useState<boolean>(false);


  // const getPreviousRecordById = (records: ISaleRecordList[], id: number) => {
  //   const index = records.findIndex(r => r.Id === id);
  //     if (index > -1 && records.length >= index + 1 ) {
  //       return records[index + 1]; // one high index because the sale record is in descending order
  //     }
  //     return null;
  //   }

  useEffect(() => {
    GetStorePaymentByStoreId(storeId);
    // if(isDisabled){
    //   let prevRecord = getPreviousRecordById(allSalesRecord, saleRecordId);
    //   let prevRecorId = prevRecord ? prevRecord.Id : -1;
    //   if(prevRecorId > 0)
    //     GetSMRPaymentDetailsBySaleRecordId(prevRecorId);
    // }
    // else
      GetSMRPaymentDetailsBySaleRecordId(saleRecordId);
  }, [storeId]);

  const calculateTotalDeposit = (values: IStoreSeletedPaymentList[]) => {
    let totalDepoit: number = 0;
    if (values && values.length > 0)
      totalDepoit = values?.reduce(
        (sum: number, item: IStoreSeletedPaymentList) => {
          let tempAmount = toHalfWidth(item.Amount);
          if (item.IsSelected && item.Amount) {
            return (
              sum +
              (typeof tempAmount == "string"
                ? parseInt(tempAmount, 10)
                : tempAmount)
            );
          }
          return sum;
        },
        0
      );

    return totalDepoit;
  };

  const calculateTotalDue = (totalAmout: number, amountDeposited: number) => {
    let totalDue: number = totalAmout - amountDeposited;
    return totalDue;
  };

  

  const submitHandler = (values: IPaymentSMRVM) => {
    let selectedMethods = values.StoreSeletedPayments?.filter(
      (item: IStoreSeletedPaymentList) => item.IsSelected
    );
    let requestObj: Array<{ PaymentModeId: number, Amount: number | string }> = [];
    if (selectedMethods.length > 0)
      selectedMethods.map((payment) => {
        let amount = typeof payment.Amount === "string" ? parseInt(payment.Amount) : payment.Amount;
        // if (amount > 0)
          requestObj.push({
            PaymentModeId: payment.Id,
            Amount: amount,
          });
      });
    if(requestObj?.length > 0){
      if (isAddAccounting)
        AddPaymentDetailsBySaleRecordIdService({
          Date: formValues.Date,
          Time: formValues.Time,
          StaffId: formValues.StaffId,
          SMRId: smrId,
          SaleId: saleRecordId,
          AppointmentId: formValues.AppointmentId,
          PaymentDetailsLists: requestObj,
          Dob: customerDetail?.Dob ? customerDetail.Dob : null,
          Gender: customerDetail.Gender,
          CustomerId: customerId,
          StoreId: storeId,
          BusinessTypeId: getBusinessTypeIdFromLocalStorage(),
          IsNew:
            customerDetail?.TotalCount > 0
              ? SMROldNewEnum.Old
              : SMROldNewEnum.New,
        });
      else {
        UpdatePaymentDetailsBySaleRecordIdService({
          SaleId: saleRecordId,
          PaymentDetailsLists: requestObj,
        });
      }
    }
  };

  useEffect(() => {
    if (addUpdatePaymentDetailsBySaleRecordIdState.success) {
      if (isAddAccounting) toast.success(formatMessage("payment_added"));
      else toast.success(formatMessage("payment_updated"));
      modalClosed();
    }
  }, [addUpdatePaymentDetailsBySaleRecordIdState.success]);

  return (
    <>
      <Modal className="fancy-modal" show={true} size="lg" centered>
        <Modal.Header>
          <Modal.Title>
            <FormattedMessage id="payment" />
            <button
              onClick={modalClosed}
              disabled={addUpdatePaymentDetailsBySaleRecordIdState.success}
              className="Crossicons"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="23"
                height="23"
                fill="currentColor"
                className="bi bi-x"
                viewBox="0 0 16 16"
              >
                <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
              </svg>
            </button>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-0">
          {paymentDetailBySaleRecordIdState.inProgress ||
            getByIdPaymentInStoreState.inProgress || addUpdatePaymentDetailsBySaleRecordIdState.inProgress ? (
            <FormLoader
              loading={
                paymentDetailBySaleRecordIdState.inProgress ||
                getByIdPaymentInStoreState.inProgress ||
                addUpdatePaymentDetailsBySaleRecordIdState.inProgress
              }
            />
          ) : null}
          <Formik
            initialValues={storeSeletedPaymentModesForSMR}
            enableReinitialize
            validationSchema={accountingValidationSchema}
            validateOnBlur={false}
            onSubmit={async (values) => {
              let total = calculateTotalDeposit(values.StoreSeletedPayments);
              if (total !== values.Total) {
                setErr(true);
                setTimeout(() => {
                  setErr(false);
                }, 3000);
              } else if(values.StoreSeletedPayments?.filter(
                (item: IStoreSeletedPaymentList) => item.IsSelected
              )?.length === 0){
                setErr(true);
                setTimeout(() => {
                  setErr(false);
                }, 3000);
              }
              else{
                setErr(false);
                submitHandler({
                  ...values,
                  StoreSeletedPayments: values.StoreSeletedPayments?.map(
                    (item: any) => ({
                      ...item,
                      Amount: isNaN(item.Amount)
                        ? toHalfWidth(item.Amount)
                        : Number(toHalfWidth(item.Amount)),
                    })
                  ),
                });
              }
            }}
          >
            {({ values, setFieldValue }) => {
              return (
                <Form className="user-form">
                  <div className="row g-0">
                    <div className="col-md-4">
                      <div className="row g-0 h5 border-bottom py-2 px-4">
                        <div className="col-12">
                          <FormattedMessage id="payment" />
                        </div>
                      </div>
                      <FieldArray
                        name="StoreSeletedPayments"
                        render={() => (
                          <div className="resolution py-2 px-4 method-list">
                            {values.StoreSeletedPayments &&
                              values.StoreSeletedPayments.length > 0 ? (
                              values.StoreSeletedPayments.map(
                                (paymentMode: any, index: number) => (
                                  <div key={index} className="method-item">
                                    <div className="label-style method-checkbox">
                                      <Field
                                        className="mx-1"
                                        name={`StoreSeletedPayments.${index}.IsSelected`}
                                        type="checkbox"
                                        as={FormikFormCheckBox}
                                        disabled={isDisabled}
                                        onUncheckClear={() => {
                                          setFieldValue(`StoreSeletedPayments.${index}.Amount`, "");
                                        }}
                                        onCheckSetAmount={() => {
                                          const totalDue = calculateTotalDue(
                                            values.Total,
                                            calculateTotalDeposit(values.StoreSeletedPayments)
                                          );
                                          setFieldValue(`StoreSeletedPayments.${index}.Amount`, totalDue);
                                        }}
                                      />
                                      <label
                                        htmlFor={`StoreSeletedPayments.${index}.IsSelected`}
                                      >
                                        {paymentMode.Name}
                                      </label>
                                    </div>
                                  </div>
                                )
                              )
                            ) : (
                              <div className="text-danger text-center">
                                <Nodata />
                                <strong>
                                  <FormattedMessage id="no_payment_method_selected_for_store" />
                                </strong>
                              </div>
                            )}
                          </div>
                        )}
                      />
                    </div>
                    <div className="col-md-8 border-start">
                      <div className="row g-0 h5 border-bottom py-2 px-4 ">
                        <div className="col-6">
                          {formatMessage("actual")}: {formatNumberWithCommas(values.Total)}
                        </div>
                        <div className="col-6 text-end"></div>
                      </div>
                      <div className="row g-0 py-2 px-4 ">
                        <div className="col-12">
                          {formatMessage("total")}: {formatNumberWithCommas(values.Total)}
                          <small className="text-muted ms-2">       
                            <span>
                              <FormattedMessage id="total_tax" /> :
                              {formatNumberWithCommas(taxDetail)}
                            </span>                     
                            {/* {Object.entries(invoiceDetails.TaxBreakdown).map(
                              ([taxRate, value]) => (
                                <>
                                  <span>
                                    <FormattedMessage id="tax_label" /> ({taxRate}):
                                   {value}
                                  </span> {" + "}
                                </>
                              )
                            )} */}
                            </small>
                            {/* <small className="text-muted">
                          {formatMessage("consumption_tax")} ( {props.consumptionTax?.TaxValue}%) :{" "}
                          {values.ConsumptionTax}
                          </small> */}
                        </div>
                      </div>
                      <div className="py-2 px-4 ">
                        <div className="card bg-light p-3 paymentTransactions">
                          <FieldArray
                            name="StoreSeletedPayments"
                            render={() => (
                              <>
                                {values.StoreSeletedPayments &&
                                  values.StoreSeletedPayments.length > 0 &&
                                  values.StoreSeletedPayments.map(
                                    (paymentMode: any, index: number) => {
                                      return (
                                        <>
                                          {paymentMode.IsSelected && (
                                            <div
                                              key={index}
                                              className="row g-0 align-items-center mt-2"
                                            >
                                              <label className="col-sm-6">
                                                {paymentMode.Name}:
                                              </label>
                                              <div className="col-sm-6">
                                                <Field
                                                  name={`StoreSeletedPayments.${index}.Amount`}
                                                  className="form-control"
                                                  type="text"
                                                  placeholder="enter_amount"
                                                  regex={integerRegex}
                                                  disabled={isDisabled}
                                                  as={FormikFormInputRegexCheckFormattedNumber}
                                                />
                                              </div>
                                            </div>
                                          )}
                                        </>
                                      );
                                    }
                                  )}
                              </>
                            )}
                          />
                        </div>
                      </div>
                      <div className="py-2 px-4 border-top">
                        <p className="mb-3">
                          {formatMessage("deposit")}:{" "}
                          {formatNumberWithCommas(calculateTotalDeposit(values.StoreSeletedPayments))}
                        </p>
                        <p className="mb-3">
                          {calculateTotalDeposit(values.StoreSeletedPayments) < values.Total ? (
                            <span className="text-danger">
                              <FormattedMessage id="due" />:{" -"}
                              {formatNumberWithCommas(calculateTotalDue(
                                values.Total,
                                calculateTotalDeposit(values.StoreSeletedPayments)
                              ))}
                            </span>
                          ) : calculateTotalDeposit(values.StoreSeletedPayments) == values.Total ? (
                            <span className="text-danger">
                              <FormattedMessage id="due" />:{" "}
                              {formatNumberWithCommas(calculateTotalDue(
                                values.Total,
                                calculateTotalDeposit(values.StoreSeletedPayments)
                              ))}
                            </span>
                          ) : (
                            <span className="text-success">
                              <FormattedMessage id="change" />:{" "}
                              {formatNumberWithCommas(Math.abs(
                                calculateTotalDue(
                                  values.Total,
                                  calculateTotalDeposit(values.StoreSeletedPayments)
                                )
                              ))}
                            </span>
                          )}
                        </p>
                      </div>
                    </div>
                  </div>

                  {err && (
                    <span
                      data-testid="testError"
                      className="text-danger errorMessage d-flex justify-content-center mb-3"
                    >
                      <FormattedMessage
                        id={
                          values.StoreSeletedPayments?.filter(
                            (item: IStoreSeletedPaymentList) => item.IsSelected
                          )?.length === 0
                            ? "no_payment_mode_selected"
                            : "payment_must_be_equal"
                        }
                      />
                    </span>
                  )}

                  <div className="modal-footer text-center d-flex gap-2">
                    <Button
                      variant="outline-danger"
                      type="button"
                      disabled={
                        addUpdatePaymentDetailsBySaleRecordIdState.inProgress
                      }
                      onClick={modalClosed}
                    >
                      <i className="bi bi-x-lg me-1"></i>
                      <FormattedMessage id="close" />
                    </Button>
                    {
                      !isDisabled &&
                      <LoaderButton
                        type="submit"
                        iconName="bi-check-lg"
                        isLoading={
                          addUpdatePaymentDetailsBySaleRecordIdState.inProgress
                        }
                        text="button_save"
                      />
                    }
                  </div>
                </Form>
              );
            }}
          </Formik>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default observer(Accounting);
